var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { grow: "", shrink: "" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("bookyear")) + " "),
          _c("w-spacer"),
          _c(
            "w-dropdown",
            {
              style: { fontSize: "13px" },
              attrs: { right: "", flat: "", items: _vm.actionsList },
              on: {
                click: function ($event) {
                  return _vm.triggerAction($event)
                },
              },
            },
            [_c("w-fa", { attrs: { small: "", icon: "ellipsis-v" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      items: _vm.dates,
                      fancy: "",
                      label: _vm.$ct("begin-date"),
                    },
                    model: {
                      value: _vm.startDate,
                      callback: function ($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      items: _vm.months,
                      fancy: "",
                      label: _vm.$ct("start-month"),
                    },
                    model: {
                      value: _vm.startMonth,
                      callback: function ($$v) {
                        _vm.startMonth = $$v
                      },
                      expression: "startMonth",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.saveBookyearConfig()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }